import { useEffect, useMemo } from "react";

import useProp from "@/modules/cms/views/post/components/builder/hooks/useProp";
import createContextFactory from "@/utils/factory";

const { Provider, useContext } = createContextFactory(({ useData = useBypassData, ...props }) => {
  const data = useData(props)

  return useMemo(() => ({
    data,
  }), [data])
})

function useBypassData({ data }) {
  const prop = useProp()

  const { setValue } = prop

  useEffect(() => {
    setValue(data)
  }, [data, setValue])

  return prop
}

export {
  Provider as DnDBypassProvider,
  useContext as useDnDBypassContext,
}
